import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {
  TaskDefinitionSimpleResponse,
  TaskDefinitionStateEnum,
} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {TaskDefinitionStateEnumPill} from 'src/shared/constants/PillConstants';
import {TaskDefinitionStateDataOptions} from 'src/shared/constants/columnFilterData';
export const useTaskDefinitionColumns = () => {
  const columns = useMemo<MRT_ColumnDef<TaskDefinitionSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'subject',
        header: 'Subject',
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        accessorKey: 'creator.name',
        header: 'Created By',
      },
      {
        id: 'createdAt',
        accessorFn: row => (row.createdAt ? new Date(row.createdAt) : null),
        filterVariant: 'date',
        header: 'Created Date',
        Cell: ({cell}) => (
          <>{cell.getValue<Date | undefined>()?.toString().toShortDate()}</>
        ),
      },
      {
        id: 'dueAt',
        accessorFn: row => (row.dueAt ? new Date(row.dueAt) : null),
        filterVariant: 'date',
        header: 'Due Date',
        Cell: ({cell}) => (
          <>{cell.getValue<Date | undefined>()?.toString().toShortDate()}</>
        ),
      },
      {
        accessorKey: 'state',
        header: 'Status',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: TaskDefinitionStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<TaskDefinitionStateEnum>();
          const pillConfig = TaskDefinitionStateEnumPill(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
      {
        accessorKey: 'project.name',
        header: 'Project',
      },
    ],
    []
  );

  return columns;
};
